import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import qs from 'query-string';
import {
  Alert,
  Button,
  RadioGroup,
  Radio,
  TextField,
} from '@a-ui/react';

import * as cardActions from '../actions/card';

const optionsCards = [{
  key: 'me',
  id: 'me',
  value: 'me',
  name: 'cardOwnership',
  label: 'Mijn A-kaart / mijn sorteerpas',
}, {
  key: 'other',
  id: 'other',
  value: 'other',
  name: 'cardOwnership',
  label: 'Een andere A-kaart / een andere sorteerpas',
}];

const CardPicker = () => {
  const [cardOwnership, setCardOwnership] = useState('me');
  const [cardNumber, setCardNumber] = useState('');
  const [cardValid, setCardValid] = useState(true);
  const [activateError, setActivateError] = useState(null);
  const { card } = useSelector(state => ({
    card: state.card,
  }));
  const history = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const toUrl = qs.parse(location.search, { ignoreQueryPrefix: true }).fromUrl || '/overzicht';

  useEffect(() => {
    dispatch(cardActions.clearPass());

    if (location.state?.error) {
      setActivateError(location.state.error);
      history('.', { replace: true, state: {} });
    }
  }, []);

  useEffect(() => {
    if (cardNumber) {
      sessionStorage.setItem('cardNumber', cardNumber.replace(/ /g, ''));
    } else {
      sessionStorage.removeItem('cardNumber');
    }
  }, [cardNumber]);

  const changeCardNumber = (number) => {
    setCardNumber(number);
    if (number.length > 9 && !number.match(/90000[0-9]{7}/i)) {
      setCardValid(false);
    } else {
      setCardValid(true);
    }
  }
  const handleCancel = (e) => {
    e.preventDefault();
    window.location.href = 'https://www.antwerpen.be/sorteerstraten'
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if (cardValid || cardOwnership === 'me') {
      dispatch(cardActions.getCard({
        cardNumber: cardNumber.replace(/ /g, ''),
        cardOwnership: cardOwnership,
      }));
    }
  }

  if (card.fetched) {
    history(toUrl);
  }

  if (card.error === 'activate') {
    history('activeren');
  }

  if (card.error === 'link') {
    history('koppelen');
  }

  return (
    <div className="row ">
      <div className="col-md-6 col-md-offset-3 col-xs-12">
        <div className="box">
          <h5>Sorteerpas kiezen</h5>

          <form className="u-margin-top" onSubmit={handleSubmit}>
            {(card.error || activateError) && <div className="u-margin-bottom"><Alert theme="danger" inline={true}><div dangerouslySetInnerHTML={{ __html: card.error || activateError }} /></Alert></div>}
            <div className="card-ownership-select u-margin-bottom">
              <RadioGroup
                name="cardOwnership"
                label="Duid aan van welke sorteerpas u het saldo wil raadplegen."
                options={optionsCards}
                value={cardOwnership}
                onChange={setCardOwnership}
              >
                {optionsCards.map((optionsCard) => <Radio
                  {...optionsCard}
                />)}
              </RadioGroup>
            </div>

            {cardOwnership === 'other' && <TextField
              name="cardNumber"
              label="Vul hieronder het nummer van uw A-kaart of sorteerpas in"
              description={(!cardValid ? 'Dit is geen geldig kaartnummer' : <span>Een A-kaart nummer bestaat uit 12 cijfers<br /> Een sorteerpasnummer bestaat maximum uit 7 cijfers</span>)}
              required
              state={cardValid ? 'success' : 'error'}
              value={cardNumber}
              onChange={(e) => changeCardNumber(e.target.value)} />
            }

            <div className="actions u-margin-top">
              <Button
                disabled={card.loading}
                htmlType="submit"
                {...(card.loading && {
                  addOn: {
                    type: 'spinner',
                  },
                })}
              >Saldo sorteerpas bekijken</Button>
              <Button emphasis="low" onClick={handleCancel}>Annuleren</Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CardPicker;
